import moment from "moment-jalaali";
import { gql, useLazyQuery } from "@apollo/client";
import momentJalaaliGenerateConfig from "@general/momentJalali";
import generateCalendar from "antd/es/calendar/generateCalendar";
import calendarLocale from "./locale";
import "moment/locale/fa";
import { useState, useEffect } from "react";
import { Col, Skeleton, Row, Alert, Select, Form, Tag } from "antd";
const Calendar = generateCalendar(momentJalaaliGenerateConfig);
const GETPURCHASES = gql`
  query ($paginateInput: PaginateInput!, $searchInput: PurchaseSearchInput!) {
    getPurchases(paginateInput: $paginateInput, searchInput: $searchInput) {
      id
      createdAt
      startAt
      endAt
      purchaseType
      user {
        id
        name
        mobile
      }
      product {
        id
        name
        category
      }
      reserve {
        startAt
        endAt
        product {
          name
          id
        }
      }
    }
  }
`;
const GETMEETINGROOMSLIST = gql`
  query ($paginateInput: PaginateInput!, $searchInput: ProductSearchInput!) {
    getProducts(paginateInput: $paginateInput, searchInput: $searchInput) {
      name
      id
    }
  }
`;
moment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });

function AdminCalendar(props) {
  const [purchasesData, setPurchasesData] = useState(null);
  const [meetingRooms, setMeetingRooms] = useState(null);
  const [selectedMeetingRoom, setSelectedMeetingRoom] = useState(null);
  const [meetingRoomMeetings, setMeeitngRoomMeetings] = useState([]);
  const [calendarValue, setCalendarValue] = useState(moment());

  const [getPurchases, purchases] = useLazyQuery(GETPURCHASES, {
    fetchPolicy: "no-cache",
    onCompleted({ getPurchases }) {
      setPurchasesData(getPurchases);
    },
  });
  const [getMeetingRoomsList, meetingRoomsList] = useLazyQuery(
    GETMEETINGROOMSLIST,
    {
      fetchPolicy: "no-cache",
      onCompleted({ getProducts }) {
        setMeetingRooms(getProducts);
        setSelectedMeetingRoom(getProducts[0]);
      },
    }
  );

  useEffect(() => {
    getMeetingRoomsList({
      variables: {
        paginateInput: {},
        searchInput: {
          category: "MEETING_ROOM",
        },
      },
    });
    getPurchases({
      variables: {
        paginateInput: {},
        searchInput: {},
      },
    });
  }, []);

  useEffect(() => {
    const consultationMeetings = [];
    const reqularMeetings = [];

    if (meetingRooms?.length && selectedMeetingRoom?.id) {
      purchasesData?.map((purchase) => {
        // if (
        //   purchase?.reserve &&
        //   purchase?.reserve?.product.id === selectedMeetingRoom.id
        // ) {
        //   consultationMeetings.push({
        //     type: "consultation",
        //     user: purchase?.user?.name ?? purchase?.user?.mobile,
        //     from: purchase.reserve.startAt,
        //     to: purchase.reserve.endAt,
        //   });
        // }

        if (
          // !purchase?.reserve &&
          // purchase?.product &&
          purchase?.product?.category === "MEETING_ROOM" &&
          purchase.product.id === selectedMeetingRoom.id
        ) {
          reqularMeetings.push({
            // type: "reqular",
            user: purchase?.user?.name ?? purchase?.user?.mobile,
            from: purchase.startAt,
            to: purchase.endAt,
          });
        }
      });
    }

    setMeeitngRoomMeetings([...consultationMeetings, ...reqularMeetings]);
  }, [selectedMeetingRoom?.id, purchasesData]);

  const monthCellRender = (date) => {
    const currentMonth = moment(date).format("jYYYY-jMM");
    const meetingsCount = meetingRoomMeetings?.filter(
      (mt) =>
        moment(mt.from).format("jYYYY-jMM") ===
          moment(mt.to).format("jYYYY-jMM") &&
        moment(mt.from).format("jYYYY-jMM") === currentMonth
    ).length;

    return (
      <div className="notes-month">
        {meetingsCount ? (
          <span>{`${meetingsCount} جلسه در اتاق ${selectedMeetingRoom.name} در این ماه رزرو شده`}</span>
        ) : null}
      </div>
    );
  };

  const dayCellRender = (date) => {
    const currentDay = moment(date).format("jYYYY-jMM-jDD");
    const currentDayMeetings = meetingRoomMeetings?.filter(
      (mt) =>
        moment(mt.from).format("jYYYY-jMM-jDD") ===
          moment(mt.to).format("jYYYY-jMM-jDD") &&
        moment(mt.from).format("jYYYY-jMM-jDD") === currentDay
    );
    if (currentDayMeetings.length)
      return (
        <div className="calendar-events">
          {currentDayMeetings?.map((mt) => {
            // if (mt.type === "reqular")
              return (
                <Tag color="blue" style={{padding: "0 1px"}}>{`${mt.user} از ${moment(
                  mt.from
                ).format("HH:mm")} تا ${moment(mt.to).format("HH:mm")}`}</Tag>
              );

            // if (mt.type === "consultation")
            //   return (
            //     <Tag color="green">{`مشاوره ی ${mt.user} از ${moment(
            //       mt.from
            //     ).format("HH:mm")} تا ${moment(mt.to).format("HH:mm")}`}</Tag>
            //   );
          })}
        </div>
      );
  };

  return (
    <>
      <Row>
        <Col span={12}>
          {meetingRoomsList.loading ? (
            <Skeleton active round />
          ) : meetingRoomsList.data && meetingRooms ? (
            <Form.Item label="انتخاب اتاق جلسه">
              <Select
                value={selectedMeetingRoom?.id}
                onChange={(value) => {
                  const room = meetingRooms.find((room) => room.id === value);
                  setSelectedMeetingRoom(room);
                }}
                style={{
                  width: 160,
                }}
                options={meetingRooms.map((mt) => ({
                  label: mt.name,
                  value: mt.id,
                }))}
              />
            </Form.Item>
          ) : (
            <Alert
              message="خطایی در حین دریافت اتاق جلسات رخ داده لطفا دوباره تلاش کنید!"
              type="error"
            />
          )}
        </Col>
      </Row>
      {selectedMeetingRoom && (
        <Calendar
          key={
            selectedMeetingRoom?.id + "-" + calendarValue?.format("jYYYY-jMM")
          }
          value={calendarValue}
          onChange={(val) => setCalendarValue(val)}
          locale={calendarLocale}
          fullscreen={true}
          dateCellRender={dayCellRender}
          monthCellRender={monthCellRender}
        />
      )}
    </>
  );
}

export default AdminCalendar;
